var now = +new Date();
var index = 0;

export default function uid() {
  return "rc-upload-" + now + "-" + ++index;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-upload@2.6.1@rc-upload/es/uid.js
// module id = 385
// module chunks = 0 1